import { DOM, isBrowser } from '@app/utils';

class googleAnalyticsClient {
  /**
   *
   */
  static get isReady() {
    return isBrowser && Object.prototype.hasOwnProperty.call(window, 'ga');
  }

  /**
   *
   */
  static init() {
    if (
      typeof document === 'undefined' ||
      typeof window === 'undefined' ||
      typeof DOM === 'undefined'
    ) {
      return;
    }

    if (Object.prototype.hasOwnProperty.call(window, 'ga')) {
      window.ga('require', 'ec');
      window.ga('set', 'currencyCode', 'USD');
    } else {
      // In GDPR situations, we store the document.referrer in a cookie
      // so that during the location selector and cookie accept workflows we can
      // persist the values until finally it is set.
      const { referrer } = document;
      if (referrer && referrer.indexOf(window.location.href) === -1) {
        const currentAttributionData = DOM.getLocalStorage(
          'stockx_attribution_referrer',
        );

        if (!currentAttributionData) {
          DOM.setLocalStorage('stockx_attribution_referrer', { referrer });
        }
      }
    }
  }

  /**
   * Set Global GA data, any attributes set this way will continue to be sent to GA for every call
   */
  static setGlobalGAProps(params) {
    if (!this.isReady) {
      return;
    }

    window.ga('set', params);
  }

  /**
   *
   * @param params
   */
  static event(params) {
    if (!this.isReady) {
      return;
    }

    window.ga('send', {
      hitType: 'event',
      ...params,
    });
  }
}

export default googleAnalyticsClient;
